import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { View, TouchableOpacity } from 'react-native'
import Txt from '../Txt'
import Icon from '../Icons'
import { useTheme } from '../../theming/ThemeProvider'
import { getDateFormat, getCardsLocationText } from '../../tools/dataParse'
import { getOrderStatusColor, getOrderStatus } from '../../tools/objectMapValues'
import { usePlatforms } from '../../hooks/usePlatforms'
import Identity from '../../utils/Identity'
import useStyles from './useStyles'
import LocationInformation from './LocationsInformation'
import { useSelector } from 'react-redux'
import { loadDetailSelector } from '../../redux/loadDetails/loadDetailsSelector'

const Card = ({ item, handleEdit, handleDetail }) => {
  const { origin, destination, tractor, brokerageStatus, stopsCount, orderNumber } = item
  const { isTablet, isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const { loadDetails } = useSelector(loadDetailSelector)
  const styles = useStyles(theme, isTablet, isDesktop)
  const color = getOrderStatusColor(brokerageStatus)

  const Status = useMemo(() => (
    <View
      style={[
        styles.status,
        { backgroundColor: theme[color] }
      ]}
    >
      <Txt
        color='WHITE_TEXT'
        text={getOrderStatus(brokerageStatus)}
        identity='body3Bold'
      />
    </View>
  ), [brokerageStatus, color, styles.status, theme])

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={[
        styles.cardStyle,
        Identity.Shadow(theme).Card,
        loadDetails && loadDetails.load && loadDetails.load.orderNumber === orderNumber && styles.selected
      ]}
      onPress={() => handleDetail(item)}
    >
      {isTablet && Status}
      <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View style={[styles.location, isTablet && { flex: isDesktop ? 4 : 3 }]}>
          <LocationInformation
            origin={getCardsLocationText(origin)}
            destination={getCardsLocationText(destination)}
            originText={getDateFormat(origin?.arrivals[0])}
            destinationText={getDateFormat(destination?.arrivals[0])}
            stopsCount={stopsCount}
            showStops
            style={{
              flexDirection: isTablet ? 'row' : 'column'
            }}
          />
        </View>
        <View style={styles.information}>
          {!isTablet && Status}
          <View style={styles.number}>
            <Txt
              color='OUTER_SPACE'
              text={isTablet ? (tractor?.tractor_number || '--') : 'Tractor Nº'}
              identity={isTablet ? 'body2' : 'body2Bold'}
              style={{
                textAlign: isTablet ? 'left' : 'right'
              }}
            />
            <Txt
              color='SLATE_GRAY'
              text={isTablet ? 'Tractor Nº' : (tractor?.tractor_number || '--')}
              identity='body3'
              style={{
                textAlign: isTablet ? 'left' : 'right'
              }}
            />
          </View>
          <View style={styles.number}>
            <Txt
              color='OUTER_SPACE'
              text={isTablet ? (tractor?.trailer_number || '--') : 'Trailer Nº'}
              identity={isTablet ? 'body2' : 'body2Bold'}
              style={{
                textAlign: isTablet ? 'left' : 'right'
              }}
            />
            <Txt
              color='SLATE_GRAY'
              text={isTablet ? 'Trailer Nº' : (tractor?.trailer_number || '--')}
              identity='body3'
              style={{
                textAlign: isTablet ? 'left' : 'right'
              }}
            />
          </View>
        </View>
      </View>
      {handleEdit && (
        <TouchableOpacity
          activeOpacity={0.8}
          style={[styles.menuOptions]}
          onPress={() => handleEdit(item)}
        >
          <Icon
            fill={theme.SLATE_GRAY_TEXT}
            name='Edit'
            height={isDesktop ? 20 : 18}
            width={isDesktop ? 20 : 18}
          />
        </TouchableOpacity>)}
      <View style={[styles.marked, !isTablet && { backgroundColor: theme[color] }]} />
    </TouchableOpacity>
  )
}

Card.propTypes = {
  item: PropTypes.object.isRequired,
  handleEdit: PropTypes.any,
  handleDetail: PropTypes.func.isRequired
}

function areEqual (prevProps, nextProps) {
  // if (prevProps?.item && nextProps?.item) {
  //   return JSON.stringify(prevProps?.item) === JSON.stringify(nextProps?.item)
  // }
  return false
}

export default React.memo(Card, areEqual)
